import { useState } from "react";
import Input from "../../common/components/Input";
import ListPageTopSection from "../../common/components/ListPageTopSection";
import PageWrapper from "../../common/components/PageWrapper";
import NetworkMetadataBox from "../components/NetworkMetadataBox";
import NetworkTrendChartBox from "../components/NetworkTrendChartBox";
import { MonthlyPeriod } from "global";

const FUTURE_ERROR = "현재 년/월 이상은 선택할 수 없습니다";

export default function NetworkDashboardContainer() {
  const today = new Date();
  const todayYear = today.getFullYear();
  const todayMonth = today.getMonth() + 1;

  /**
   * Note: Html type=month input accepts and returns string values in 'yyyy-mm' format
   */
  const maxPeriod = `${todayYear}-${todayMonth.toString().padStart(2, "0")}`;

  const [period, setPeriod] = useState<MonthlyPeriod>({
    year: todayYear,
    month: todayMonth,
  });

  /**
   * Handler for when user opens up the date picker dropdown and selects a specific year/month value
   */
  const onPeriodChange = (selected: string) => {
    if (!selected) {
      return setPeriod({
        year: todayYear,
        month: todayMonth,
      });
    }

    const [newYear, newMonth] = selected.split("-").map((item) => +item);

    if (
      newYear === 1 ||
      newYear > todayYear ||
      (newYear === todayYear && newMonth > todayMonth)
    ) {
      alert(FUTURE_ERROR);
      return;
    }

    setPeriod({
      year: newYear,
      month: newMonth,
    });
  };

  /**
   * Handler for when user changes the date by pressing up/down on year or month
   */
  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (period.month === 1 && event.key === "ArrowDown") {
      event.preventDefault();

      setPeriod({
        year: period.year - 1,
        month: 12,
      });
    }

    if (period.month === 12 && event.key === "ArrowUp") {
      event.preventDefault();
      const newYear = period.year + 1;

      const isFuture =
        newYear > todayYear || (newYear === todayYear && 1 > todayMonth);

      if (isFuture) {
        alert(FUTURE_ERROR);
        return;
      }

      setPeriod({
        year: newYear,
        month: 1,
      });
    }
  };

  return (
    <PageWrapper>
      <ListPageTopSection>
        <Input
          type="month"
          className="w-1/6"
          value={`${period.year}-${period.month.toString().padStart(2, "0")}`}
          defaultValue={maxPeriod}
          max={maxPeriod}
          onKeyDown={onKeyDown}
          onValueChange={onPeriodChange}
        />
      </ListPageTopSection>
      <div className="flex gap-1 overflow-hidden">
        <NetworkMetadataBox period={period} />
        <NetworkTrendChartBox period={period} />
      </div>
    </PageWrapper>
  );
}
